/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as UnitService} from "../../../Services/UnitService";
import {NumberFieldViewer} from "./NumberFieldViewer";
import React from "react";

export class UnitNumberFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			units: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		UnitService.Get()
			.then((x) => {
				this.setState({units: x.result});
			});
	}

	@autobind
	getUnitId() {
		let unitId = -1;

		if (this.props.FieldDef && this.props.FieldDef.customData && this.props.FieldDef.customData.unitId) {
			unitId = this.props.FieldDef.customData.unitId;
		}

		return unitId;
	}

	@autobind
	getUnit() {
		let unitId = this.getUnitId();

		return this.state.units.find((x) => x.unitId == unitId);
	}


	@autobind
	_render() {
		let unit = this.getUnit();
		let isPrefix = unit?.isPrefix || false;
		let unitLabel = unit?.abbreviation || "";

		return <NumberFieldViewer Value={this.props.Value} isPrefix={isPrefix} suffix={unitLabel}
		                          className="sb-unit-number-editor"/>;
	}
}